import { HYDRATE } from "next-redux-wrapper";
import { ActionsListCategory } from "./actions";

const initialState = { data: [], status: "fetch_init", message: "" };

function storeListCategory(state = initialState, action) {
	switch (action.type) {
		case HYDRATE:
			return { ...state, ...action.payload.storeListCategory };
		case ActionsListCategory.LOAD_GET_LIST_CATEGORY:
			return { ...state, data: action.data, status: "fetch_loading" };
		case ActionsListCategory.RES_GET_LIST_CATEGORY:
			return { ...state, data: action.data, status: "fetch_result" };
		case ActionsListCategory.ERR_GET_LIST_CATEGORY:
			return {
				...state,
				data: action,
				status: "fetch_error",
				message: "Error...",
			};
		default:
			return { ...state };
	}
}

export default storeListCategory;
